<template>
  <div class="new-route-form">
    <h2 class="form-title">Добавить новый маршрут</h2>
    <form @submit.prevent="addRoute" class="form-container">

      <label class="form-label">Город отправления:</label>
      <input
        type="text"
        v-model="form.departure_city"
        class="form-input"
        placeholder="Введите город отправления"
      />

      <label class="form-label">Регион отправления:</label>
      <select v-model="form.departure_region" class="form-select">
        <option v-for="region in regions" :key="region.id" :value="region.name">
          {{ region.name }}
        </option>
      </select>

      <label class="form-label">Город назначения:</label>
      <input
        type="text"
        v-model="form.destination_city"
        class="form-input"
        placeholder="Введите город назначения"
      />

      <label class="form-label">Регион назначения:</label>
      <select v-model="form.destination_region" class="form-select">
        <option v-for="region in regions" :key="region.id" :value="region.name">
          {{ region.name }}
        </option>
      </select>

      <label class="form-label">Ставка без НДС:</label>
      <input type="number" v-model="form.bid" class="form-input" />

      <label class="form-label">Ставка с НДС:</label>
      <input type="number" v-model="form.bid_tax" class="form-input" />

      <div class="form-actions">
        <button type="submit" class="form-button form-button-submit">Добавить</button>
      </div>
    </form>
  </div>
</template>

<script>
import { reactive, computed, onMounted } from "vue";
import { useStore } from "vuex";

export default {
  name: "NewRouteForm",
  setup(props, { emit }) {
    const store = useStore();

    const form = reactive({
      departure_region: "",
      departure_city: "",
      destination_region: "",
      destination_city: "",
      bid: "",
      bid_tax: "",
    });

    const regions = computed(() => store.state.newAti.regions);

    const addRoute = async () => {
      try {
        await store.dispatch("newAti/createRoute", form);
        emit("close");
      } catch (error) {
        alert("Ошибка при добавлении маршрута: " + error.message);
      }
    };

    const closeForm = () => {
      emit("close");
    };

    onMounted(() => {
      store.dispatch("newAti/fetchRegions");
    });

    return {
      form,
      regions,
      addRoute,
      closeForm,
    };
  },
};
</script>

<style scoped>
.new-route-form {
  max-width: 500px;
  margin: 0 auto;
  background-color: #ffffff;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.form-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
}

.form-container {
  display: flex;
  flex-direction: column;
}

.form-label {
  margin-bottom: 5px;
  font-size: 14px;
}

.form-input,
.form-select {
  margin-bottom: 15px;
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
}

.form-input:focus,
.form-select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.form-actions {
  display: flex;
  justify-content: space-between;
}

.form-button {
  padding: 8px 15px;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.form-button-submit {
  background-color: #28a745;
  color: #ffffff;
}

.form-button-submit:hover {
  background-color: #218838;
}

.form-button-cancel {
  background-color: #dc3545;
  color: #ffffff;
}

.form-button-cancel:hover {
  background-color: rgb(200, 35, 51);
}
</style>
